module.exports = __webpack_public_path__ + "img/xr_ppd.ce66e44b.jpg";